
import React from 'react';
import { BaseMessage } from '../index';
import { MessageParamsInput } from '../MessageParams';
import { MessageSubtypes } from '../../constants'
import { MessageSubtype } from '../../models/MessageParams';

interface LinkPreviewMessageInput extends MessageParamsInput {
  domain?: string;
  url?: string;
  description?: string;
  title?: string;
  image?: string;
}

class PreviewMessage extends BaseMessage {
  readonly subtype: Extract<MessageSubtype, typeof MessageSubtypes.PREVIEW> = MessageSubtypes.PREVIEW;
  
  domain: string;
  url: string;
  description: string;
  title: string;
  image: string;

  constructor(messageParamsInput: LinkPreviewMessageInput) {
    super(messageParamsInput);
    Object.assign(this, messageParamsInput);
    this.domain = messageParamsInput.domain || '';
    this.url = messageParamsInput.url || '';
    this.description = messageParamsInput.description || '';
    this.title = messageParamsInput.title || '';
    this.image = messageParamsInput.image || '';
  }

  renderText(TextNode: keyof JSX.IntrinsicElements | React.ComponentType<{dangerouslySetInnerHTML: { __html: string }}>) {
    const Element = TextNode as keyof JSX.IntrinsicElements;
    return React.createElement(Element, {}, this.text)
  }
}

export default PreviewMessage;
